module.exports = __webpack_public_path__ + "static/media/section5_img3.5e0faf36.jpg";